import { motion } from "framer-motion"
import { loopSteps } from "@/data/loop"

export function LearningLoop() {
  return (
    <section id="loop" className="py-24 bg-surface-card">
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-16">
          <p className="text-caption text-primary mb-3">学习闭环</p>
          <h2 className="text-heading text-ink mb-4">
            四步，走完一个学习闭环
          </h2>
          <p className="text-body text-ink-soft max-w-xl mx-auto">
            智因不只是记录错题的本子，更是一套让你「不再错」的流程。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {loopSteps.map((step, index) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: index * 0.08 }}
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 rounded-md bg-info-soft flex items-center justify-center shrink-0">
                  <step.icon className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="text-caption text-ink-soft">{step.step}</p>
                  <p className="text-label text-primary">{step.phase}</p>
                </div>
              </div>
              <h3 className="text-heading-sm text-ink mb-2">{step.title}</h3>
              <p className="text-body text-ink-soft">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
